module.exports = __webpack_public_path__ + "img/148862695775447_image.jpg";